<dynamic-view-v2
    *ngIf="!isLoading"
    entityType="dynamic-mystery-box"
    [viewName]="title"
    [record]="dynamicMysteryBoxRecord"
    [fields]="fields"
    [showLocalizedValuesButton]="true"
>
</dynamic-view-v2>

